<template>
  <div class="margin-subpages">
    <div class="flex-center pb-20">
      <div class="fs-18 fw-700">{{ $t('awards.happily_awards') }}</div>
      <div class="ml-auto flex-center">
        <div
          :class="`year-buttom ${years == yearFocus ? 'focus' : ''}`"
          v-for="years in yearOptions"
          :key="years + '_buttom'"
          @click.prevent="selectedYears(years)"
        >
          {{ years }}
        </div>
        <div
          @click.prevent="selectedYears('allTime')"
          :class="`year-buttom ${'allTime' == yearFocus ? 'focus' : ''}`"
        >
          {{ $t('awards.all_time') }}
        </div>
      </div>
    </div>
    <div class="awards-card">
      <div class="box-image flex-mid">
        <div class="relative">
          <img
            class="img-banner"
            src="@/assets/images/awards/recognition-driven.png"
          />
        </div>
      </div>
      <div class="fs-12 fw-700">
        <div class="fs-16 fw-900 mb-4">{{ $t('awards.recognition_driven') }}</div>
        <div>
          {{ $t('awards.the_practice_of') }}
        </div>
        <div class="mt-12">
          {{ $t('awards.consistency') }}:
          <span class="fw-400">{{ recognitionDriven.consistency }}%</span>
        </div>
        <div class="mt-2">
          {{ $t('awards.current_streak') }}:
          <span class="fw-400">{{ recognitionDriven.currentStreak }} {{ $t('awards.days') }}</span>
        </div>
        <div v-if="!recognitionDrivenLoading">
          <div class="flex fw-700 mt-16 mb-8">
            <div v-if="'allTime' == yearFocus">{{ $t('awards.start_date') }}</div>
            <div v-else>{{ $t('awards.january_one') }}, {{ yearFocus }}</div>
            <div class="ml-auto">{{ $t('awards.today') }}</div>
          </div>
          <div class="flex-center progrress-box">
            <div
              v-for="(value, index) in recognitionDriven.timeLine"
              :key="index + '_' + value"
              class="value"
              :style="`width: ${
                recognitionDriven.width
              }px; height: 8px; background: ${
                value
                  ? 'linear-gradient(180deg, #F97628 0%, #D6471D 100%) 0% 0% no-repeat padding-box;'
                  : 'transparent'
              }`"
            ></div>
          </div>
          <div class="mt-6">
            {{ $t('awards.highlighted_are_periods') }}
            {{ recognitionDriven.periods }}% 
            {{ $t('awards.or_higher') }}
          </div>
        </div>
        <div v-else class="mt-16">
          <div class="flex-center">
            <div class="text-skeleton fs-12" style="width: 70px">&nbsp;</div>
            <div class="text-skeleton fs-12 ml-auto" style="width: 40px">
              &nbsp;
            </div>
          </div>
          <div class="text-skeleton fs-8 mt-8 bd-r-4" style="width: 100%">
            &nbsp;
          </div>
          <div class="text-skeleton fs-12 mt-4" style="width: 320px">
            &nbsp;
          </div>
        </div>
      </div>
    </div>

    <div class="awards-card">
      <div class="box-image flex-mid">
        <div class="relative">
          <img
            class="img-banner"
            src="@/assets/images/awards/open-feedback.png"
          />
        </div>
      </div>
      <div class="fs-12 fw-700">
        <div class="fs-16 fw-900 mb-4">{{ $t('awards.open_feedback') }}</div>
        <div>
          {{ $t('awards.continuous_feedback_drives') }}
        </div>
        <div class="mt-12">
          {{ $t('awards.consistency') }}:
          <span class="fw-400">{{ openFeedback.consistency }}%</span>
        </div>
        <div class="mt-2">
          {{ $t('awards.current_streak') }}:
          <span class="fw-400">{{ openFeedback.currentStreak }} {{ $t('awards.days') }}</span>
        </div>
        <div v-if="!openFeedbackLoading">
          <div class="flex fw-700 mt-16 mb-8">
            <div v-if="'allTime' == yearFocus">{{ $t('awards.start_date') }}</div>
            <div v-else>{{ $t('awards.january_one') }}, {{ yearFocus }}</div>
            <div class="ml-auto">{{ $t('awards.today') }}</div>
          </div>
          <div class="flex-center progrress-box">
            <div
              v-for="(value, index) in openFeedback.timeLine"
              :key="index + '_' + value"
              class="value"
              :style="`width: ${openFeedback.width}px; height: 8px; background: ${
                value
                  ? 'linear-gradient(180deg, #D0DD22 0%, #3BA637 100%) 0% 0% no-repeat padding-box;'
                  : 'transparent'
              }`"
            ></div>
          </div>
          <div class="mt-6">
            {{ $t('awards.highlighted_are_periods') }}
            {{ openFeedback.periods }}% {{ $t('awards.or_higher') }}
          </div>
        </div>
        <div v-else class="mt-16">
          <div class="flex-center">
            <div class="text-skeleton fs-12" style="width: 70px">&nbsp;</div>
            <div class="text-skeleton fs-12 ml-auto" style="width: 40px">
              &nbsp;
            </div>
          </div>
          <div class="text-skeleton fs-8 mt-8 bd-r-4" style="width: 100%">
            &nbsp;
          </div>
          <div class="text-skeleton fs-12 mt-4" style="width: 320px">
            &nbsp;
          </div>
        </div>
      </div>
    </div>

    <div class="awards-card">
      <div class="box-image flex-mid">
        <div class="relative">
          <img
            class="img-banner"
            src="@/assets/images/awards/active_managers.png"
          />
        </div>
      </div>
      <div class="fs-12 fw-700">
        <div class="fs-16 fw-900 mb-4">{{ $t('awards.active_managers') }}</div>
        <div>
          {{ $t('awards.people_managers_are') }}
        </div>
        <div class="mt-12">
          {{ $t('awards.consistency') }}:
          <span class="fw-400">{{ activeManagers.consistency }}%</span>
        </div>
        <div class="mt-2">
          {{ $t('awards.current_streak') }}:
          <span class="fw-400">{{ activeManagers.currentStreak }} {{ $t('awards.days') }}</span>
        </div>
        <div v-if="!activeManagersLoading">
          <div class="flex fw-700 mt-16 mb-8">
            <div v-if="'allTime' == yearFocus">{{ $t('awards.start_date') }}</div>
            <div v-else>{{ $t('awards.january_one') }}, {{ yearFocus }}</div>
            <div class="ml-auto">{{ $t('awards.today') }}</div>
          </div>
          <div class="flex-center progrress-box">
            <div
              v-for="(value, index) in activeManagers.timeLine"
              :key="index + '_' + value"
              class="value"
              :style="`width: ${
                activeManagers.width
              }px; height: 8px; background: ${
                value
                  ? 'linear-gradient(180deg, #30B8E5 0%, #3352A8 100%) 0% 0% no-repeat padding-box;'
                  : 'transparent'
              }`"
            ></div>
          </div>
          <div class="mt-6">
            {{ $t('awards.highlighted_are_periods') }}
            {{ activeManagers.periods }}% {{ $t('awards.or_higher') }}
          </div>
        </div>
        <div v-else class="mt-16">
          <div class="flex-center">
            <div class="text-skeleton fs-12" style="width: 70px">&nbsp;</div>
            <div class="text-skeleton fs-12 ml-auto" style="width: 40px">
              &nbsp;
            </div>
          </div>
          <div class="text-skeleton fs-8 mt-8 bd-r-4" style="width: 100%">
            &nbsp;
          </div>
          <div class="text-skeleton fs-12 mt-4" style="width: 320px">
            &nbsp;
          </div>
        </div>
      </div>
    </div>

    <div class="awards-card">
      <div class="box-image flex-mid">
        <div class="relative">
          <img
            class="img-banner"
            src="@/assets/images/awards/strong_core_values.png"
          />
        </div>
      </div>
      <div class="fs-12 fw-700">
        <div class="fs-16 fw-900 mb-4">{{ $t('awards.strong_company_culture') }}</div>
        <div>
          {{ $t('awards.culture_is_a_byproduct') }}
        </div>
        <div class="mt-12">
          {{ $t('awards.consistency') }}:
          <span class="fw-400">{{ strongCompanyCulture.consistency }}%</span>
        </div>
        <div class="mt-2">
          {{ $t('awards.current_streak') }}:
          <span class="fw-400"
            >{{ strongCompanyCulture.currentStreak }} {{ $t('awards.days') }}</span
          >
        </div>
        <div v-if="!strongCompanyCultureLoading">
          <div class="flex fw-700 mt-16 mb-8">
            <div v-if="'allTime' == yearFocus">{{ $t('awards.start_date') }}</div>
            <div v-else>{{ $t('awards.january_one') }}, {{ yearFocus }}</div>
            <div class="ml-auto">{{ $t('awards.today') }}</div>
          </div>
          <div class="flex-center progrress-box">
            <div
              v-for="(value, index) in strongCompanyCulture.timeLine"
              :key="index + '_' + value"
              class="value"
              :style="`width: ${
                strongCompanyCulture.width
              }px; height: 8px; background: ${
                value
                  ? 'linear-gradient(180deg, #F22531 0%, #A3122A 100%) 0% 0% no-repeat padding-box;'
                  : 'transparent'
              }`"
            ></div>
          </div>
          <div class="mt-6">
            {{ $t('awards.highlighted_are_periods') }}
            {{ strongCompanyCulture.periods }} {{ $t('awards.or_higher') }}
          </div>
        </div>
        <div v-else class="mt-16">
          <div class="flex-center">
            <div class="text-skeleton fs-12" style="width: 70px">&nbsp;</div>
            <div class="text-skeleton fs-12 ml-auto" style="width: 40px">
              &nbsp;
            </div>
          </div>
          <div class="text-skeleton fs-8 mt-8 bd-r-4" style="width: 100%">
            &nbsp;
          </div>
          <div class="text-skeleton fs-12 mt-4" style="width: 320px">
            &nbsp;
          </div>
        </div>
      </div>
    </div>

    <div class="awards-card">
      <div class="box-image flex-mid">
        <div class="relative">
          <img
            class="img-banner"
            src="@/assets/images/awards/high_well-being.png"
          />
        </div>
      </div>
      <div class="fs-12 fw-700">
        <div class="fs-16 fw-900 mb-4">{{ $t('awards.high_well_being') }}</div>
        <div>
          {{ $t('awards.employee_wellness_and') }}
        </div>
        <div class="mt-12">
          {{ $t('awards.consistency') }}:
          <span class="fw-400">{{ highWellBeing.consistency }}%</span>
        </div>
        <div class="mt-2">
          {{ $t('awards.current_streak') }}:
          <span class="fw-400">{{ highWellBeing.currentStreak }} {{ $t('awards.days') }}</span>
        </div>
        <div v-if="!highWellBeingLoading">
          <div class="flex fw-700 mt-16 mb-8">
            <div v-if="'allTime' == yearFocus">{{ $t('awards.start_date') }}</div>
            <div v-else>{{ $t('awards.january_one') }}, {{ yearFocus }}</div>
            <div class="ml-auto">{{ $t('awards.today') }}</div>
          </div>
          <div class="flex-center progrress-box">
            <div
              v-for="(value, index) in highWellBeing.timeLine"
              :key="index + '_' + value"
              class="value"
              :style="`width: ${
                highWellBeing.width
              }px; height: 8px; background: ${
                value
                  ? 'linear-gradient(180deg, #48D749 0%, #0F7F3B 100%) 0% 0% no-repeat padding-box;'
                  : 'transparent'
              }`"
            ></div>
          </div>
          <div class="mt-6">
            {{ $t('awards.highlighted_are_periods') }}
            {{ highWellBeing.periods }} {{ $t('awards.or_higher') }}
          </div>
        </div>
        <div v-else class="mt-16">
          <div class="flex-center">
            <div class="text-skeleton fs-12" style="width: 70px">&nbsp;</div>
            <div class="text-skeleton fs-12 ml-auto" style="width: 40px">
              &nbsp;
            </div>
          </div>
          <div class="text-skeleton fs-8 mt-8 bd-r-4" style="width: 100%">
            &nbsp;
          </div>
          <div class="text-skeleton fs-12 mt-4" style="width: 320px">
            &nbsp;
          </div>
        </div>
      </div>
    </div>

    <div class="awards-card fc-FFFFFF" style="background: #6c30cc">
      <div class="box-image flex-mid">
        <div class="relative">
          <img
            class="img-banner"
            src="@/assets/images/awards/happiest_workplace.png"
          />
        </div>
      </div>
      <div class="fs-12 fw-700">
        <div class="fs-16 fw-900 mb-4">{{ $t('awards.happiest_workplace') }}</div>
        <div>
          {{ $t('awards.a_happy_workplace') }}
        </div>
        <div class="mt-12">
          {{ $t('awards.consistency') }}:
          <span class="fw-400">{{ happiestWorkplace.consistency }}%</span>
        </div>
        <div class="mt-2">
          {{ $t('awards.current_streak') }}:
          <span class="fw-400">{{ happiestWorkplace.currentStreak }} {{ $t('awards.days') }}</span>
        </div>
        <div
          v-if="
            (!recognitionDrivenLoading &&
            !openFeedbackLoading &&
            !activeManagersLoading &&
            !strongCompanyCultureLoading &&
            !highWellBeingLoading)
          "
        >
          <div class="flex fw-700 mt-16 mb-8">
            <div v-if="'allTime' == yearFocus">{{ $t('awards.start_date') }}</div>
            <div v-else>{{ $t('awards.january_one') }}, {{ yearFocus }}</div>
            <div class="ml-auto">{{ $t('awards.today') }}</div>
          </div>
          <div class="flex-center progrress-box">
            <div
              v-for="(value, index) in happiestWorkplace.timeLine"
              :key="index + '_' + value"
              class="value"
              :style="`width: ${
                happiestWorkplace.width
              }px; height: 8px; background: ${
                value
                  ? 'transparent linear-gradient(180deg, #FFFFFF 0%, #888888 100%) 0% 0% no-repeat padding-box;'
                  : 'transparent'
              }`"
            ></div>
          </div>
          <div class="mt-6">{{ $t('awards.required_collect_all') }}</div>
        </div>
        <div v-else class="mt-16">
          <div class="flex-center">
            <div class="text-skeleton fs-12" style="width: 70px">&nbsp;</div>
            <div class="text-skeleton fs-12 ml-auto" style="width: 40px">
              &nbsp;
            </div>
          </div>
          <div class="text-skeleton fs-8 mt-8 bd-r-4" style="width: 100%">
            &nbsp;
          </div>
          <div class="text-skeleton fs-12 mt-4" style="width: 320px">
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format from "date-fns/format";
import { stat } from "fs";
export default {
  name: "timeline-subpages",
  data() {
    return {
      //
      // recognitionDriven: {
      //   timeLine: true,
      //   consistency: 49,
      //   currentStreak: 0,
      //   periods: 70,
      //   length: 0,
      //   width: 0,
      // },
      // openFeedback: {
      //   timeLine: true,
      //   consistency: 60,
      //   currentStreak: 0,
      //   periods: 40,
      //   length: 0,
      //   width: 0,
      // },
      // activeManagers: {
      //   timeLine: true,
      //   consistency: 60,
      //   currentStreak: 0,
      //   periods: 50,
      //   length: 0,
      //   width: 0,
      // },
      // strongCompanyCulture: {
      //   timeLine: true,
      //   consistency: 60,
      //   currentStreak: 0,
      //   periods: 80,
      //   length: 0,
      //   width: 0,
      // },
      // highWellBeing: {
      //   timeLine: true,
      //   consistency: 60,
      //   currentStreak: 0,
      //   periods: 80,
      //   length: 0,
      //   width: 0,
      // },
      // happiestWorkplace: {
      //   timeLine: true,
      //   consistency: 0,
      //   currentStreak: 0,
      //   periods: 5,
      //   length: 0,
      //   width: 0,
      // },
      yearFocus: new Date().getFullYear(),
      yearOptions: [],
    };
  },
  computed: {
    recognitionDriven() {
      return this.$store.getters["awards/recognitionDrivenTimeline"];
    },
    happiestWorkplace() {
      return this.$store.getters["awards/happiestWorkplaceTimeline"];
    },
    openFeedback() {
      return this.$store.getters["awards/openFeedbackTimeline"];
    },
    activeManagers() {
      return this.$store.getters["awards/activeManagersTimeline"];
    },
    strongCompanyCulture() {
      return this.$store.getters["awards/strongCompanyCultureTimeline"];
    },
    highWellBeing() {
      return this.$store.getters["awards/highWellBeingTimeline"];
    },

    recognitionDrivenLoading() {
      return this.$store.getters["awards/recognitionDrivenLoading"];
    },
    openFeedbackLoading() {
      return this.$store.getters["awards/openFeedbackLoading"];
    },
    activeManagersLoading() {
      return this.$store.getters["awards/activeManagersLoading"];
    },
    strongCompanyCultureLoading() {
      return this.$store.getters["awards/strongCompanyCultureLoading"];
    },
    highWellBeingLoading() {
      return this.$store.getters["awards/highWellBeingLoading"];
    },
  },

  created() {
    this.$store.dispatch("awards/getOpenEnded", this.yearFocus);
    this.$store.dispatch(
      "awards/getRecognitionAndActiveManager",
      this.yearFocus
    );
    this.$store.dispatch("awards/getCultureAndHighWellBeing", this.yearFocus);
  },
  mounted() {
    setTimeout(() => {
      this.$store.dispatch(
        "awards/gethappiestWorkplaceSetData",
        this.yearFocus
      );
    }, 5000);

    let nowYear = new Date().getFullYear();
    for (let i = 2019; i <= nowYear; i++) {
      this.yearOptions.push(i);
    }
  },
  methods: {
    selectedYears(year) {
      this.yearFocus = year;
      this.$store.dispatch("awards/getOpenEnded", this.yearFocus);
      this.$store.dispatch(
        "awards/getRecognitionAndActiveManager",
        this.yearFocus
      );
      this.$store.dispatch("awards/getCultureAndHighWellBeing", this.yearFocus);
    },
  },
};
</script>

<style lang="scss" scoped>
.awards-card {
  margin: 30px 0px 60px;
  border-radius: 4px;
  box-shadow: 0px 3px 6px #00000029;
  padding: 16px 24px 16px 0;
  display: grid;
  grid-template-columns: 152px auto;
  .box-image {
    width: 100%;
    .relative {
      width: 2px;
      height: 2px;
    }
    .img-banner {
      width: 120px;
      position: absolute;
      left: 50%;
      right: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .progrress-box {
    border-radius: 8px;
    overflow: hidden;
    height: 8px;
    background-color: rgba($color: #000000, $alpha: 0.1);
    .value {
      &:last-child {
        max-width: 727px;
        min-width: 4px;
      }
    }
  }
}
.year-buttom {
  padding: 8px 16px;
  border-radius: 4px;
  color: #6c30cc;
  transition: 0.2s;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  margin: 0 3px;
  &:hover {
    background-color: rgba($color: #6c30cc, $alpha: 0.05);
  }
}
.focus {
  cursor: default;
  background-color: rgba($color: #6c30cc, $alpha: 0.1);
  &:hover {
    background-color: rgba($color: #6c30cc, $alpha: 0.1);
  }
}
</style>